import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ensureArray',
    standalone: true,
})
export class EnsureArrayPipe implements PipeTransform {
    transform(value: any): any[] {
        if (!value) {
            return [];
        } else if (Array.isArray(value)) {
            return value;
        } else {
            return [value];
        }
    }
}
